import React from "react";

import { FilterChangeHandler, WSFilterValues } from "./types";

export const InternalState = React.createContext<{
  values: WSFilterValues;
  onChange: FilterChangeHandler;
}>({ values: {}, onChange: () => {} });

export const useInternalState = () => React.useContext(InternalState);
